import { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { RemindersComingSoonModal } from "@/components/modal/reminders-coming-soon/reminders-coming-soon-modal";
import { useRemindersEnableActions } from "@/pages/settings/use-reminders-enable-actions";
import { useAppStore } from "@/store";

/**
 * Renders the Reminders coming-soon modal from the app overlay layer.
 */
export const SettingsRemindersComingSoonOverlay = observer(() => {
  const { store } = useAppStore();
  const { memAgent } = store;
  const { enableOption, isEnablingSlack } = useRemindersEnableActions();

  const handleClose = useCallback(() => {
    memAgent.closeRemindersComingSoonModal();
  }, [memAgent]);

  const handleEnableSlack = useCallback(() => {
    memAgent.closeRemindersComingSoonModal();
    enableOption("Slack");
  }, [enableOption, memAgent]);

  return (
    <RemindersComingSoonModal
      isOpen={memAgent.remindersComingSoonOption !== null}
      option={memAgent.remindersComingSoonOption}
      isEnablingSlack={isEnablingSlack}
      onClose={handleClose}
      onEnableSlack={handleEnableSlack}
    />
  );
});
